export const complexityOptions = [
    { value: '0', label: 'новичок' },
    { value: '5', label: 'средний' },
    { value: '10', label: 'профессионал' },
    { value: undefined, label: 'все' },
];

export const priceOptions = [
    { value: 'true', label: 'бесплатные' },
    { value: 'false', label: 'платные' },
    { value: undefined, label: 'все' },
];
